namespace GeniuzPOS.Purchase {
    export interface PoPo06PendingCNforCnrtvRow {
        SysDocNo?: string;
        UseFg?: number;
        CreditNoteNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        SupplierId?: string;
        SupplName?: string;
        ShipId?: string;
        TaxInvoiceRef?: string;
        ShipDate?: string;
        PayTermCode?: string;
        WhsId?: string;
        ReceiptAmt?: number;
        Remark?: string;
        DtList?: PoPo06DtPendingCNforCnrtvRow[];
    }

    export namespace PoPo06PendingCNforCnrtvRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPo06PendingCNforCnrtv';
        export const lookupKey = 'Purchase.PoPo06PendingCNforCnrtv';

        export function getLookup(): Q.Lookup<PoPo06PendingCNforCnrtvRow> {
            return Q.getLookup<PoPo06PendingCNforCnrtvRow>('Purchase.PoPo06PendingCNforCnrtv');
        }
        export const deletePermission = '5Purchase:รายงาน:รายงานใบคืนสินค้าคงค้าง:View';
        export const insertPermission = '5Purchase:รายงาน:รายงานใบคืนสินค้าคงค้าง:View';
        export const readPermission = '5Purchase:รายงาน:รายงานใบคืนสินค้าคงค้าง:View';
        export const updatePermission = '5Purchase:รายงาน:รายงานใบคืนสินค้าคงค้าง:View';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            UseFg = "UseFg",
            CreditNoteNo = "CreditNoteNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            ShipId = "ShipId",
            TaxInvoiceRef = "TaxInvoiceRef",
            ShipDate = "ShipDate",
            PayTermCode = "PayTermCode",
            WhsId = "WhsId",
            ReceiptAmt = "ReceiptAmt",
            Remark = "Remark",
            DtList = "DtList"
        }
    }
}
